import { Component } from '@angular/core';
import { AslibEnviromentService } from '@aslib/enviroment';

import { environment } from './../environments/environment';
import { BaseConfig } from './shared/service/base-config.service';

@Component({
  selector: 'sarf-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'SARF - BA';

  constructor(public aslibEnviromentService: AslibEnviromentService) {
    this.aslibEnviromentService.config<BaseConfig>().then(() => this.aslibEnviromentService.replace(environment));
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts